
import { DandDFeatureSource } from "@dndModels/feature_sources";
import { DataType } from "@dndModels/Types";

/**
 * This is represents a job title within an org.
 */
export class OrgPosition extends DandDFeatureSource {
  data_type: DataType = "org_position";
  feature_source_type = "OrgPosition";
  org_id = "";

  constructor(obj?: any) {
    super(obj, "OrgPosition");
    if (obj) {
      this.org_id = obj.org_id ? obj.org_id : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.org_id = obj.org_id ? obj.org_id : "";
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      org_id: this.org_id
    };
  }

  copy(copyMe: OrgPosition, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.org_id = copyMe.org_id;
  }

  clone(drop_ids = false): OrgPosition {
    const new_obj = new OrgPosition();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
